import React from 'react';
import { Col, Form, Row, Select } from 'components';
import { FormModal } from 'components/common';
import { ManagementRoleMapping } from 'models/Manager';
import { useEditManagement } from './useEditManagement';

export interface IManagementUpdate {
  onCancel: () => void;
  openUpdateModal: boolean;
}

export const EditManagementModal = React.memo((props: IManagementUpdate) => {
  const { onCancel, openUpdateModal } = props;
  const { onFinish, userData, form, isLoading, onModalCancel, handleManagerChange } = useEditManagement({
    onCancel,
    openUpdateModal,
  });

  return (
    <FormModal
      form={form}
      title={'Update Brand Management'}
      okText={'Save'}
      open={openUpdateModal}
      isLoading={isLoading}
      onCancel={onModalCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label={ManagementRoleMapping.purchaseManager} name={'purchaseManagerId'}>
            <Select
              size={'large'}
              options={userData}
              onSelect={(value) => handleManagerChange(value, 'purchaseManagerAssistantId')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.purchaseManagerId !== currentValues.purchaseManagerId
            }
          >
            {({ getFieldValue }) => {
              return (
                <Form.Item label={ManagementRoleMapping.purchaseManagerAssistant} name={'purchaseManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('purchaseManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('purchaseManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={ManagementRoleMapping.postSalesManager} name={'postSalesManagerId'}>
            <Select
              size={'large'}
              options={userData}
              onSelect={(value) => handleManagerChange(value, 'postSalesManagerAssistantId')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.postSalesManagerId !== currentValues.postSalesManagerId
            }
          >
            {({ getFieldValue }) => {
              return (
                <Form.Item label={ManagementRoleMapping.postSalesManagerAssistant} name={'postSalesManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('postSalesManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('postSalesManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
});
